(function () {
  function initTalkingAbout(sectionEl) {
    var track = sectionEl.querySelector(".talking-about__track");
    var sourceList = track && track.querySelector(".talking-about__list");
    if (!track || !sourceList) return;

    var sourceHTML = sourceList.innerHTML;
    var safety = 0;

    while (sourceList.scrollWidth < window.innerWidth && safety < 20) {
      sourceList.insertAdjacentHTML("beforeend", sourceHTML);
      safety++;
    }

    var clone = sourceList.cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    clone.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.removeAttribute("loading");
    });
    track.appendChild(clone);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll(".talking-about").forEach(initTalkingAbout);
    });
  } else {
    document.querySelectorAll(".talking-about").forEach(initTalkingAbout);
  }
})();
